import React from "react";
import useAuth from "@/hooks/useAuth";
import { Link } from "react-router-dom";

export default function LoginUnauthorized() {
  const auth = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-sm w-full bg-white rounded-lg shadow-md p-8 text-center">
        <img src="/img/velaro.svg" alt="Velaro" className="h-8 mx-auto mb-6" />
        <p className="text-gray-700 font-medium mb-2">Access Denied</p>
        <p className="text-sm text-gray-500 mb-6">
          You are not authorized to access Velaro Admin. Contact your administrator
          to request access.
        </p>
        <button
          onClick={() => auth.retryLogin()}
          className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm font-medium mb-3"
        >
          Try a Different Account
        </button>
        <Link
          to="/logout"
          className="block text-xs text-gray-400 hover:text-gray-600"
        >
          Sign Out
        </Link>
      </div>
    </div>
  );
}
